import React, { createContext, useState, useContext } from 'react';

interface MyContextType {
    state: any;
    updateState: (key: string, value: any) => void;
}

// Provide a default value that aligns with the MyContextType interface
const MoonJellyContext = createContext<MyContextType>({
    state: "Finance-Blue-Print-1",
    updateState: () => { },
});

export const MyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // Initialize bluePrint in the state
    const [state, setState] = useState({
        bluePrint: "Finance-Blue-Print-1",
        sideBar: "dashboard",
        sidebarCollapsed: true,
        messageFooterId: '',
        chatHistorythreadId:'',
        updateType:'percentilechart',
        getData:'',
        isKgSidebarOpen: false,
        kgSidebarData: null,
        isDocLinkSidebarOpen: false,
        docLinkSidebarData: null,
    });

    // Create a function to update the state
    const updateState = (key: string, value: any) => {
        setState((prevState) => {
            // If the value is the same as the current value, don't update
            if (key !== "getData" && prevState[key] === value) {
                return prevState;
            }
            
            const updatedValue = key === "getData"
                ? [...(Array.isArray(prevState[key]) ? prevState[key] : []), value] // Ensure it's an array and append
                : value;
   
            return {
                ...prevState,
                [key]: updatedValue,
            };
        });
    };

    return (
        <MoonJellyContext.Provider value={{ state, updateState }}>
            {children}
        </MoonJellyContext.Provider>
    );
};

// Custom hook to use the context
export const useMyContext = () => {
    return useContext(MoonJellyContext);
};
